import * as React from 'react';
import { myroom } from '../../../../model/myroom';
import { ListItem, ListItemText, withStyles } from '@material-ui/core';
import { styles } from './styles';
import { StyledComponentProps } from '@material-ui/core/styles';
import moment from 'moment';

export interface IRoomProps extends StyledComponentProps {
    myroom: myroom;
}
const Room = (props: IRoomProps) => {
    let name: string = '';
    let formatted: string = '';
    if (props.myroom && props.myroom.description) {
        name = props.myroom.description
    };
    if (props.myroom && props.myroom.endDate) {
        const appo = new Date(props.myroom.endDate);
        formatted = appo.toLocaleDateString('it-IT', { day: 'numeric', month: 'short', year: 'numeric' });
    };
    const getRoomAccessStyle = () => {
        if (props.myroom && props.myroom.endDate) {
            if (moment(props.myroom.endDate).toDate() >= (new Date())) {
                return { backgroundColor: '#90ee90' };
            }
        }
        return { textDecorationLine: 'line-through', textDecorationColor: 'red' };
    }
    const r = () => {
        return (<ListItem key={props.myroom._id} className={props.classes.root} button style={getRoomAccessStyle()}>
                <ListItemText style={{ width: '70%' }} color="textSecondary" primary={name} className={props.classes.blackColor} />
                <ListItemText style={{ width: '30%', textAlign: 'end' }} color="textSecondary" primary={formatted} className={props.classes.blackColor} />
            </ListItem>)
        // if (props.myroom._id !== null &&  props.myroom._id)
        // return <></>
    }
    // text-decoration-line: line-through;
    // text-decoration-color: red;
    return (r());
}

export default withStyles(styles)(Room)